import SharedModal from "./SharedModal";

export default SharedModal;
